// extracted by mini-css-extract-plugin
export var checkboxInputRow = "s_rf";
export var checkboxInputColumn = "s_rg";
export var inputOptionRow = "s_qq";
export var inputOptionColumn = "s_qr";